import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, Row, Col, Typography, Spin, Divider } from 'antd';
import { UserOutlined, LockOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import './LoginPage.css';

const { Title, Text } = Typography;

const LoginPage = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { login, loading } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (values) => {
    setIsLoading(true);
    const result = await login(values.email, values.password);
    setIsLoading(false);

    if (result.success) {
      setTimeout(() => {
        navigate('/');
      }, 500);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <Row justify="center" align="middle" style={{ minHeight: '100vh', width: '100%' }}>
          <Col xs={24} sm={22} md={18} lg={10} xl={7}>
            <Spin spinning={loading || isLoading} size="large">
              <Card className="login-card" bordered={false} style={{ borderRadius: '12px' }}>
                {/* Logo Section */}
                <div className="login-header">
                  <div className="logo-wrapper">
                    <EnvironmentOutlined className="logo-icon" />
                  </div>
                </div>

                {/* Title Section */}
                <div className="title-section">
                  <Title level={2} className="login-title">Forage</Title>
                  <Text className="login-subtitle">Système de Gestion de l'Eau</Text>
                </div>

                <Divider style={{ margin: '24px 0' }} />

                {/* Login Form */}
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleLogin}
                  style={{ width: '100%' }}
                  requiredMark={false}
                  size="large"
                >
                  <Form.Item
                    name="email"
                    label={<span style={{ fontWeight: 500 }}>Email</span>}
                    rules={[
                      { required: true, message: 'Veuillez entrer votre email' },
                      { type: 'email', message: 'Email invalide' }
                    ]}
                    style={{ marginBottom: '16px' }}
                  >
                    <Input
                      prefix={<UserOutlined />}
                      placeholder="Entrez votre email"
                      size="large"
                      className="login-input"
                    />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    label={<span style={{ fontWeight: 500 }}>Mot de passe</span>}
                    rules={[
                      { required: true, message: 'Veuillez entrer votre mot de passe' }
                    ]}
                    style={{ marginBottom: '16px' }}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="••••••••"
                      size="large"
                      className="login-input"
                    />
                  </Form.Item>

                  {/* Demo Credentials Box - HIDDEN FOR SECURITY */}
                  {/* <div className="demo-box">
                    <Text strong>Comptes de démonstration :</Text>
                    <div style={{ marginTop: '8px', fontSize: '13px', lineHeight: '1.6' }}>
                      <div><span style={{ color: '#666' }}>Email:</span> <code>admin@forage.com</code></div>
                      <div><span style={{ color: '#666' }}>Mot de passe:</span> <code>admin123</code></div>
                    </div>
                  </div> */}

                  <Form.Item style={{ marginBottom: 0, marginTop: '24px' }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      block
                      loading={isLoading}
                      className="login-button"
                    >
                      Se connecter
                    </Button>
                  </Form.Item>
                </Form>

                {/* Footer */}
                <div style={{ textAlign: 'center', marginTop: '24px' }}>
                  <Text type="secondary" style={{ fontSize: '12px' }}>
                    © 2026 Forage - Tous droits réservés
                  </Text>
                </div>
              </Card>
            </Spin>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default LoginPage;
